import { Box, Container } from '@mui/system';
import React from 'react';
import { Seo } from '../seo';
import { Theme, Typography, useMediaQuery } from '@mui/material';
import logo from './error-401.png';

type Props = {};

const NotPermission = (props: Props) => {
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return (
    <>
      <Seo title="Error: Not Found" />
      <Box
        component="main"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          py: '80px',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 6,
            }}
          >
            <img
              alt="Not found"
              src={logo}
              style={{
                height: 'auto',
                maxWidth: '80%',
                width: 300,
              }}
            />
          </Box>
          <Box>
            <Typography
              align="center"
              variant={mdUp ? 'h3' : 'h4'}
            >
              404 Page not Found
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default NotPermission;
